// Simple locale selector following Shopify's localization.js pattern
document.addEventListener("DOMContentLoaded", function () {
  const selector = document.getElementById("locale-selector-select");
  const form = document.getElementById("locale-selector-form");

  if (!selector || !form) return;

  const countryInput = form.querySelector('input[name="country_code"]');
  const languageInput = form.querySelector('input[name="language_code"]');

  function changeLanguage(/** @type {Event} */ event) {
    if (!event.target) return;

    const value = event.target.value;

    if (!(value && value.includes("|"))) {
      return;
    }

    const [countryCode, languageCode] = value.split("|");

    if (countryInput) countryInput.value = countryCode;
    if (languageInput) languageInput.value = languageCode;

    form?.submit();
  }

  // Handle selection change using changeLanguage pattern
  selector.addEventListener("change", changeLanguage);
});
